/* eslint-disable no-return-assign */
import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import Text from "@redbubble/design-system/react/Text";
import Box from "@redbubble/design-system/react/Box";
import Button from "@redbubble/design-system/react/Button";
import * as constants from "@redbubble/design-system/react/constants";
import { analyticsPayload } from "../../lib/analytics";
import { getLogInUrl, getSignUpUrl } from "./utils";
import { loginFormMessages as messages } from "./messages";
import { intlPropType } from "../../lib/propTypes";

const LoginSignup = ({ intl, logEvent, analyticsLabel }) => {
  useEffect(() => {
    logEvent({ analytics: analyticsPayload.signup("view", analyticsLabel) });
  }, [logEvent, analyticsLabel]);

  const returnUrl = useMemo(() => new URL(window.location.href), []);

  return (
    <React.Fragment>
      <Text type="display2" element="h2" display="block" marginBottom="m">
        {intl.formatMessage(messages.callToAction)}
      </Text>

      <Box marginBottom="m">
        <Text element="p" display="block" type="body2">
          {intl.formatMessage(messages.caption)}
        </Text>
      </Box>

      <Box>
        <Box marginBottom="s">
          <Button
            strong
            fluid
            intent={constants.PRIMARY}
            size={constants.LARGE}
            href={getSignUpUrl(returnUrl)}
          >
            {intl.formatMessage(messages.signUp)}
          </Button>
        </Box>

        <Box>
          <Button
            strong
            fluid
            size={constants.LARGE}
            href={getLogInUrl(returnUrl)}
          >
            {intl.formatMessage(messages.logIn)}
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

LoginSignup.displayName = "LoginSignup";

LoginSignup.propTypes = {
  intl: intlPropType.isRequired,
  logEvent: PropTypes.func.isRequired,
  analyticsLabel: PropTypes.string.isRequired,
};

LoginSignup.defaultProps = {};

export default LoginSignup;
